export enum EnumContactCategory {
    Owner = '00000264-1000-0000-0000-000000000001',
    CEO = '00000264-1000-0000-0000-000000000002',
    CTO = '00000264-1000-0000-0000-000000000003',
    CFO = '00000264-1000-0000-0000-000000000004',
    Account_Manager = '00000264-1000-0000-0000-000000000005',
    Claims_Manager = '00000264-1000-0000-0000-000000000006',
    Claims_Billing = '00000264-1000-0000-0000-000000000007',
    Main_Contact = '00000264-1000-0000-0000-000000000008',
}
